import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">大家都在关注的影视分类</p>

          <div className="flex flex-wrap justify-center gap-3">
            {topicsData.map((topic) => (
              <a
                key={topic.id}
                href={`#topics`}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  topic.hot
                    ? 'bg-primary-50 text-primary-700 hover:bg-primary-100 border border-primary-200'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-300/60'
                }`}
              >
                <span className={`w-5 h-5 flex items-center justify-center`}>
                  <i className={`${topic.icon} ${topic.hot ? 'text-primary-500' : 'text-secondary-400'}`}></i>
                </span>
                <span>{topic.name}</span>
                <span className={`text-xs ${topic.hot ? 'text-primary-400' : 'text-foreground-400'}`}>
                  {topic.count}
                </span>
                {topic.hot && (
                  <span className="inline-flex items-center gap-0.5 text-[10px] text-primary-500 bg-primary-100 px-1.5 py-0.5 rounded-full">
                    <i className="ri-fire-line"></i>热
                  </span>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}